import GetUserResponse from '../CRM/Responses/UserResponse';

import Model from './Model';

import { isLottoAmerica } from 'utils/template';

export default class User extends Model {
    readonly id: number;
    readonly token: string;
    readonly email: string;
    readonly password: string;
    readonly balance: number;
    readonly reseller_earnings: number;
    readonly balance_status: string;
    readonly win_ratio: any;
    readonly last_win_ratio: any;
    readonly reseller_debit: number;
    readonly name: string;
    readonly last_name: string;
    readonly gender: string;
    readonly birthday: string;
    readonly address: string;
    readonly address2: string;
    readonly city: string;
    readonly phone: string;
    readonly phone_country: string;
    readonly timezone: string;
    readonly language: string;
    readonly is_reseller: boolean;
    readonly reseller_percent_revenue: number;
    readonly reseller_wants_to_become: boolean;
    readonly is_confirmed: number | null;
    readonly is_kyc_confirmed: boolean;
    readonly phone_confirmed: boolean;
    readonly postal_code: string | null;
    readonly country: string | null;
    readonly state: string | null;
    readonly last_ip: string | null;
    readonly last_country: string | null;
    readonly registration_ip: string | null;
    readonly registration_country: string | null;
    readonly first_time_deposit_date: string | null;
    readonly second_time_deposit_date: string | null;
    readonly first_time_purchase_date: string | null;
    readonly second_time_purchase_date: string | null;
    readonly purchase_sum: string;
    readonly deposit_sum: string;
    readonly withdrawal_sum: string;
    readonly referer_id: number | null;
    readonly referer_bonus_used: number;
    readonly referer_my_token_used_count: number;
    readonly created_at: string | null;
    readonly updated_at: string | null;
    readonly deleted_at: string | null;
    readonly affiliate_id: number | null;
    readonly sub_affiliate_id: number | null;
    readonly balance_formatted: string;
    readonly reseller_debit_formatted: string;
    readonly reseller_percent_revenue_formatted: string;
    readonly affiliate_name: string | null;
    readonly cpf: string | null;

    constructor(user: GetUserResponse) {
        super();
        this.assignDataToProps(user, [
            'id',
            'token',
            'email',
            'password',
            'balance',
            'reseller_earnings',
            'balance_status',
            'win_ratio',
            'last_win_ratio',
            'reseller_debit',
            'name',
            'last_name',
            'gender',
            'birthday',
            'address',
            'address2',
            'city',
            'phone',
            'phone_country',
            'timezone',
            'language',
            'is_reseller',
            'reseller_percent_revenue',
            'reseller_wants_to_become',
            'is_confirmed',
            'is_kyc_confirmed',
            'phone_confirmed',
            'postal_code',
            'country',
            'state',
            'last_ip',
            'last_country',
            'registration_ip',
            'registration_country',
            'first_time_deposit_date',
            'second_time_deposit_date',
            'first_time_purchase_date',
            'second_time_purchase_date',
            'purchase_sum',
            'deposit_sum',
            'withdrawal_sum',
            'referer_id',
            'referer_bonus_used',
            'referer_my_token_used_count',
            'created_at',
            'updated_at',
            'deleted_at',
            'affiliate_id',
            'sub_affiliate_id',
            'balance_formatted',
            'reseller_debit_formatted',
            'reseller_percent_revenue_formatted',
            'affiliate_name',
            'cpf',
        ]);
    }

    public isDeleted(): boolean {
        return this.deleted_at !== null;
    }

    public static isKycExposed() {
        return isLottoAmerica();
    }
}
